import { render, staticRenderFns } from "./SingleBanner.vue?vue&type=template&id=25f5c1d1&lang=pug&"
import script from "./SingleBanner.vue?vue&type=script&lang=js&"
export * from "./SingleBanner.vue?vue&type=script&lang=js&"
import style0 from "./SingleBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports